import types from 'actions/types'
import {accountingTypes} from 'helpers/constants'
import * as signUpFinal from 'actions/signUpFinal'
import {get} from 'lodash'
import {documentProviders} from 'helpers/integrations'

const user = (state = null, action) => {
  let accountsIntegration = {}
  switch (action.type) {

    case types.SIGN_UP_SUCCESS:
      return action.user

    case types.LOGIN_SUCCESS:
      return action.user

    case types.REFRESH_AUTH_SUCCESS:
    case types.REFRESH_AUTH_TOTP_SUCCESS:
      return {
        ...state,
        ...action.user,
      }

    case types.LOGOUT_ATTEMPT:
      return null

    case types.USERS_UPDATE_USER:
      return {
        ...action.user,
        featureToggles: get(state, 'featureToggles'),
      }

    case types.USER_DATA_READ_SUCCESS:
      return {
        ...state,
        ...action.user,
      }

    case types.SETTINGS_USER_SETTINGS_READ_SUCCESS:
    case types.SETTINGS_USER_SETTING_UPDATE_SUCCESS:
      return {
        ...state,
        settings: action.data,
      }

    case types.GOOGLE_DRIVE_CHECK_AUTH_SUCCESS:
      return {
        ...state,
        googleDriveIntegration: true,
      }

    case types.GOOGLE_DRIVE_DEAUTH_SUCCESS:
      return {
        ...state,
        googleDriveIntegration: false,
      }

    case types.XERO_AUTHENTICATE_COMPLETE:
      const xero = accountingTypes.XERO
      accountsIntegration = {
        ...state.settings.accountsIntegration,
        value: xero.title,
        id: xero.id,
        label: xero.title,
        local: xero.local,
        proOnly: xero.proOnly,
      }
      return {
        ...state,
        settings: {
          ...get(state, 'settings', {}),
          accountsIntegration,
        },
        xeroIntegration: '1',
      }

    case types.XERO_ENABLED_SUCCESS: {
      const xero = accountingTypes.XERO
      accountsIntegration = {
        ...get(state, 'settings.accountsIntegration', {}),
        value: xero.title,
        id: xero.id,
        label: xero.title,
        local: xero.local,
        proOnly: xero.proOnly,
      }
      return {
        ...state,
        settings: {
          ...get(state, 'settings', {}),
          accountsIntegration,
        },
        xeroIntegration: '1',
      }
    }

    case types.XERO_ENABLED_FAILURE:
    case types.XERO_DISABLE_SUCCESS:
      if (state.settings.accountsIntegration.id === accountingTypes.XERO.id) {
        const none = accountingTypes.NONE
        accountsIntegration = {
          ...get(state, 'settings.accountsIntegration', {}),
          value: none.title,
          id: none.id,
          label: none.title,
          local: none.local,
          proOnly: none.proOnly,
        }
        return {
          ...state,
          settings: {
            ...get(state, 'settings', {}),
            accountsIntegration,
          },
          xeroIntegration: '0',
        }
      }
      return state

    case types.QUICK_BOOKS_ENABLED_SUCCESS: {
      const quickBooks = accountingTypes.QUICK_BOOKS_ONLINE
      accountsIntegration = {
        ...get(state, 'settings.accountsIntegration', {}),
        value: quickBooks.title,
        id: quickBooks.id,
        label: quickBooks.title,
        local: quickBooks.local,
        proOnly: quickBooks.proOnly,
      }
      return {
        ...state,
        settings: {
          ...get(state, 'settings', {}),
          accountsIntegration,
        },
      }
    }

    case types.QUICK_BOOKS_ENABLED_FAILURE:
    case types.QUICK_BOOKS_DISABLE_SUCCESS: {
      if (state.settings.accountsIntegration.id === accountingTypes.QUICK_BOOKS_ONLINE.id) {
        const none = accountingTypes.NONE
        accountsIntegration = {
          ...get(state, 'settings.accountsIntegration', {}),
          value: none.title,
          id: none.id,
          label: none.title,
          local: none.local,
          proOnly: none.proOnly,
        }
        return {
          ...state,
          settings: {
            ...get(state, 'settings', {}),
            accountsIntegration,
          },
        }
      }

      return state
    }

    case types.SAGE_ENABLED_SUCCESS: {
      const sage = accountingTypes.SAGE_ONE
      accountsIntegration = {
        ...get(state, 'settings.accountsIntegration', {}),
        value: sage.title,
        id: sage.id,
        label: sage.title,
        local: sage.local,
        proOnly: sage.proOnly,
      }
      return {
        ...state,
        settings: {
          ...get(state, 'settings', {}),
          accountsIntegration,
        },
      }
    }

    case types.SAGE_ENABLED_FAILURE:
    case types.SAGE_DISABLE_SUCCESS: {
      if (state.settings.accountsIntegration.id === accountingTypes.SAGE_ONE.id) {
        const none = accountingTypes.NONE
        accountsIntegration = {
          ...get(state, 'settings.accountsIntegration', {}),
          value: none.title,
          id: none.id,
          label: none.title,
          local: none.local,
          proOnly: none.proOnly,
        }
        return {
          ...state,
          settings: {
            ...get(state, 'settings', {}),
            accountsIntegration,
          },
        }
      }

      return state
    }

    case types.DATA_LOAD_CURRENCIES_SUCCESS:
      const defaultCurrency = action.data.find(c => c.default)
      return {
        ...state,
        currencyHtmlCode: defaultCurrency ? defaultCurrency.htmlCode : '',
        currencyShortDesc: defaultCurrency ? defaultCurrency.shortDesc : '',
      }

    case signUpFinal.types.FINALISE_SUCCESS:
      return {
        ...state,
        settings: {
          ...get(state, 'settings', {}),
          locale: get(action, 'data.locale', state.settings.locale),
        },
        detailsConfirmed: true,
      }

    case signUpFinal.types.FINALISE_FAILURE:  // let them in even though it failed
      return {...state, detailsConfirmed: true}

    case types.BILLING_DETAILS_UPDATE_SUCCESS:
      return {
        ...state,
        billingCountryCode: action.data.countryCode,
      }

    case types.ZOHO_STATUS_SUCCESS:
    case types.ZOHO_AUTHENTICATE_SUCCESS:
    case types.ZOHO_ACTIVATE_SUCCESS:
    case types.ZOHO_DEACTIVATE_SUCCESS:
    case types.ZOHO_SYNC_UPDATE_SUCCESS:
      return {
        ...state,
        zohoSync: action.status && action.status.active,
      }

    case types.SET_FEATURE_TOGGLES:
      return state ? {...state, featureToggles: action.featureToggles} : state

    case types.SETTINGS_UPLOAD_LOGO_SUCCESS:
      return {
        ...state,
        companyLogoImage: action.data,
      }

    case types.SETTINGS_DELETE_LOGO_SUCCESS:
      return {
        ...state,
        companyLogoImage: null,
      }

    case types.SETTINGS_UPLOAD_SIGNATURE_SUCCESS:
      return {
        ...state,
        userSignatureImage: action.data,
      }

    case types.SETTINGS_DELETE_SIGNATURE_SUCCESS:
      return {
        ...state,
        userSignatureImage: null,
      }

    case types.ONE_DRIVE_DISABLE_SUCCESS:
    case types.SHARE_POINT_DISABLE_SUCCESS:
      return {
        ...state,
        defaultDocumentProvider: documentProviders.NONE,
      }

    case types.ACCOUNTING_SAGE50_PROVIDER_ENABLE_SUCCESS: {
      const sage50 = accountingTypes.SAGE_50
      accountsIntegration = {
        ...get(state, 'settings.accountsIntegration', {}),
        value: sage50.title,
        id: sage50.id,
        label: sage50.title,
        local: sage50.local,
        proOnly: sage50.proOnly,
      }
      return {
        ...state,
        settings: {
          ...get(state, 'settings', {}),
          accountsIntegration,
        },
        sageIntegration: 1,
      }
    }

    case types.ACCOUNTING_SAGE50_PROVIDER_DISABLE_SUCCESS: {
      if (state.settings.accountsIntegration.id === accountingTypes.SAGE_50.id) {
        const none = accountingTypes.NONE
        accountsIntegration = {
          ...get(state, 'settings.accountsIntegration', {}),
          value: none.title,
          id: none.id,
          label: none.title,
          local: none.local,
          proOnly: none.proOnly,
        }
        return {
          ...state,
          settings: {
            ...get(state, 'settings', {}),
            accountsIntegration,
          },
        }
      }

      return state
    }

    case types.ACCOUNTING_CURRENT_PROVIDER_SUCCESS: {
      return {
        ...state,
        accountsIntegration: action.result,
      }
    }

    default:
      return state
  }
}

export default user
